import * as React from 'react';

import { DataTableView, ToolbarVisibility, Column } from 'src/core/ui/data-table.view';

interface PolicyRuleListViewProps extends ComponentViewProps<DataSet<PolicyRuleItem>> {
	mode: ControlMode;
	sections: string[];
	onEditRule: (rule: PolicyRuleItem) => void;
	onCreateRule: () => Promise<void>;
}

export class PolicyRuleListView extends React.Component<PolicyRuleListViewProps, {}> {
	render(): React.ReactNode {
		const { model, sections, onEditRule, onCreateRule } = this.props;
		const columns: Column[] = [];
		if (sections.some(m => m === 'general')) {
			columns.push(
				{
					key: 'brandName',
					title: 'Brand',
					dataIndex: 'brandName'
				},
				{
					key: 'marketName',
					title: 'Market',
					dataIndex: 'marketName'
				},
				{
					key: 'regionDisplayName',
					title: 'Region',
					dataIndex: 'regionDisplayName'
				}
			);
		}

		if (sections.some(m => m === 'product')) {
			columns.push(
				{
					key: 'placeDisplayName',
					title: 'Place',
					dataIndex: 'placeDisplayName'
				},
				{
					key: 'productType',
					title: 'Product Type',
					dataIndex: 'productTypeText'
				},
				{
					key: 'productCategoryDisplayName',
					title: 'Product Category',
					dataIndex: 'productCategoryDisplayName'
				},
				{
					key: 'productDisplayName',
					title: 'Product',
					dataIndex: 'productDisplayName'
				},
				{
					key: 'supplierTitle',
					title: 'Supplier',
					dataIndex: 'supplierTitle'
				},
				{
					key: 'productProviderName',
					title: 'Product Provider ',
					dataIndex: 'productProviderName'
				}
			);
		}

		return (
			<DataTableView
				mode={this.props.mode}
				createNewItem={onCreateRule}
				setBusy={this.props.setBusy}
				columns={columns}
				model={model}
				hideToolbar={ToolbarVisibility.hideFooter | ToolbarVisibility.hidePagination | ToolbarVisibility.hideSearch}
				itemDoubleClick={onEditRule}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/policy-rules/list/policy-rule-list.view.tsx